<template>
  <v-container>
    <div class="control-panel elevation-3">
      <v-row>
        <v-col class="text-left pl-4">
          <h3>List of Offices</h3>
        </v-col>
        <v-col>
          <v-btn class="primary" @click="onShowAllClicked" :disabled="areSearchCtrlsDisabled">Reset</v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-select
            v-model="selectedAgencyId"
            :items="agencyOptions"
            label="Select Agency"
            :disabled="areSearchCtrlsDisabled || selectedAgencyId !== null"
            item-text="label"
            item-value="value"
            class="py-0"
            dense
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            v-model="selectedProgramId"
            :items="programOptions"
            label="Select Program Office"
            :disabled="areSearchCtrlsDisabled || programDropDownEnabled"
            item-text="label"
            item-value="value"
            class="py-0"
            dense
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="py-0">
          <v-select
            v-model="selectedFieldId"
            :items="fieldOptions"
            label="Select Field Office"
            :disabled="areSearchCtrlsDisabled || fieldDropDownEnabled"
            item-text="label"
            item-value="value"
            class="py-0"
            dense
          ></v-select>
        </v-col>
        <v-col class="py-0">
          <v-select
            v-model="selectedBranchId"
            :items="branchOptions"
            label="Select Branch"
            :disabled="areSearchCtrlsDisabled || branchDropDownEnabled"
            item-text="label"
            item-value="value"
            class="py-0"
            dense
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <!-- label="Search offices by name, abbreviation or code" -->
        <!-- hint="Examples: Naval Air Systems, CDC, 159900" -->
        <v-col class="pt-0">
          <v-text-field
            v-model="search"
            label="Search offices by name"
            :disabled="areSearchCtrlsDisabled"
            solo
            flat
            clearable
            clear-icon="mdi-close-circle-outline"
            class="padded search-input"
          ></v-text-field>
        </v-col>
      </v-row>
    </div>
    <!-- <v-layout data-app wrap row> -->
    <v-row>
      <v-col>
        <div class="tree-view-container">
          <div v-if="loading === true" class="text-center">
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
          </div>
          <v-treeview
            v-else
            :items="nodes"
            :open="opened"
            :active="selected"
            :value="selected"
            rounded
            hoverable
            activatable
            dense
            color="primary"
            class="offices-tree"
            @update:active="onNodeActivated"
            :search="search"
            :filter="filter"
            expand-icon="expand_more"
          >
            <template v-slot:prepend="{ item }">
              <v-img
                v-if="item.depth === 0"
                class="type-img"
                aria-hidden="true"
                contain
                :src="require('@/assets/agency.png')"
              ></v-img>
              <v-img
                v-else-if="item.depth === 1"
                class="type-img"
                aria-hidden="true"
                contain
                :src="require('@/assets/program.png')"
              ></v-img>
              <v-img
                v-else-if="item.depth === 2"
                class="type-img"
                aria-hidden="true"
                contain
                :src="require('@/assets/field.png')"
              ></v-img>
              <v-img
                v-else
                class="type-img"
                aria-hidden="true"
                contain
                :src="require('@/assets/branch.png')"
              ></v-img>
            </template>
            <template v-slot:label="{ item }" style="line-height: 27px;">
              <span class="name">{{ item.name }}</span>
              <span v-if="item.abbreviation" class="abbrev">({{ item.abbreviation }})</span>
              <span class="code">{{ item.code }}</span>
            </template>
          </v-treeview>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue';
import _ from 'lodash';
import { officeManagementService } from "@/services/officeManagementService";
import { officeNodeService } from "@/services/officeNodeService";

export default {
  name: "OfficeTreeView",
  props: {
    id: null
  },
  data: () => ({
    nodes: [],
    allNodes: [],
    active: [],
    open: [],
    selected: [],
    multiActive: false,
    search: null,
    selectedPath: null,
    opened: [],
    caseSensitive: false,
    programDisabled: true,
    fieldDisabled: true,
    branchDisabled: true,
    agencyOptions: [],
    selectedAgencyId: null,
    programOptions: [],
    selectedProgramId: null,
    fieldOptions: [],
    selectedFieldId: null,
    branchOptions: [],
    selectedBranchId: null,
    loading: false,
    areSearchCtrlsDisabled: false
  }),
  methods: {
    onShowAllClicked () {
      this.agencyOptions.splice(0, this.agencyOptions.length);
      this.selectedAgencyId = null;
      this.programOptions = [];
      this.selectedProgramId = null;
      this.fieldOptions = [];
      this.selectedFieldId = null;
      this.branchOptions = [];
      this.selectedBranchId = null;
      this.nodes = this.buildNodes(this.allNodes);

      let me = this;
      this.nodes.forEach(node => {
        if (node.depth === 0) {
          if (node && node.id && node.name) {
            me.agencyOptions.push({ value: node.id, label: node.name });
          }
        }
      });

      me.agencyOptions.sort((a, b) => {
        if (!a.label) return -1;
        if (!b.label) return 1;
        return a.label.localeCompare(b.label)
      });
    },
    buildNodes (nodesArr) {
      let me = this;
      let ret = [];
      nodesArr.forEach(node => {
        // DD - Do not add nodes with null name
        if (!node.name) {
          console.log('Unable to add node with name value of null.');
        } else {
          let newNode = {
            name: node.name,
            id: node.id,
            path: node.path,
            children: [],
            code: node.code,
            abbreviation: node.officeAbbreviation,
            depth: node.depth
          };
          ret.push(newNode);
          officeNodeService.setNode(node);

          if (node.children && node.children.length > 0) {
            newNode.children = me.buildNodes(node.children);
          }

          // get the selected path if we are looking for one
          if (me.id && me.id !== -1 && me.id !== "-1") {
            me.opened.push(node.id);
          }
        }
      });
      return ret;
    },
    expandNodes (nodeArr) {
      let me = this;
      nodeArr.forEach(node => {
        me.opened.push(node.id);
        if (node.children && node.children.length > 0) {
          me.expandNodes(node.children);
        }
      });
    },
    onNodeActivated (evt) {
      const id = evt[0];
      console.log("Node clicked: " + id);
      this.$emit("node-selected", { id: id.toString() });
    },
    getDropDownOptions (depth, fnCallback) {
      officeManagementService
        .getAllOfficesByDepth(0)
        .then(function (resp) {
          fnCallback(resp.data.offices);
        })
        .catch(function (err) {
          console.error("Error loading agency tree nodes");
          throw err;
        });
    },
    getAgencyOptions (nodes) {
      this.agencyOptions.splice(0, this.agencyOptions.length);
      let idx = 0;
      nodes.forEach(node => {
        Vue.set(this.agencyOptions, idx++, { value: node.id, label: node.name });
      });

      this.agencyOptions.sort((a, b) => {
        if (!a.label) return -1;
        if (!b.label) return 1;
        return a.label.localeCompare(b.label);
      });
    }
  },
  computed: {
    programDropDownEnabled: function () {
      return (this.selectedAgencyId === null)
    },
    fieldDropDownEnabled: function () {
      return (this.selectedProgramId === null || this.selectedFieldId !== null)
    },
    branchDropDownEnabled: function () {
      return (this.selectedFieldId === null || this.selectedBranchId !== null)
    },
    filter: _.debounce(() => {
      let ALL_VALUES = [];
      let NO_ABBREV = [];
        return (item, search, textKey) => {
          if (!search) return true;
            ALL_VALUES = [item[textKey], item.code, item.abbreviation];
            NO_ABBREV = [item[textKey], item.code];
            let term = search.toLowerCase();
            let ret = false;
            if (item.abbreviation) {
                ALL_VALUES.forEach((value) => {
                  let val = (value) ? value.toLowerCase() : '';
                  if (!ret && val && val.indexOf(term) > -1) {
                    ret = true;
                  }
                });
                return ret;
            } else {
                NO_ABBREV.forEach((value) => {
                  let val = (value) ? value.toLowerCase() : '';
                  if (!ret && val && val.indexOf(term) > -1) {
                    ret = true;
                  }
                });
                return ret;
            }
          }
    }, 750)
  },
  watch: {
    search: function (newVal, oldVal) {
      if (!newVal && !oldVal) {
        this.selected = [];
        this.opened = [];
      } // else {
      //   if (newVal) {
      //     this.expandNodes(this.nodes);
      //   } else {
      //     this.selected = [];
      //     this.opened = [];
      //   }
      // }
    },
    id: function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        let me = this;
        me.opened = [];
        me.selected = [];
        me.loading = true;
        if (newVal === "-1" || newVal === -1) {
          me.areSearchCtrlsDisabled = false;
          me.selectedPath = null;
          officeManagementService
            .getAllAgencyTrees()
            .then(function (resp) {
              me.allNodes = me.nodes = me.buildNodes(resp.data.nodes);
              me.getAgencyOptions(me.nodes);
              me.loading = false;
            })
            .catch(function (err) {
              console.log(err);
              console.log("Error loading tree nodes.");
              me.loading = false;
              throw err;
            });
        } else {
          me.areSearchCtrlsDisabled = true;
          officeManagementService
            .getOfficeTree(this.id)
            .then(function (resp) {
              me.allNodes = me.nodes = me.buildNodes(resp.data.nodes);
              me.selected.push(me.id.toString());
              me.onNodeActivated([me.id]);
              me.loading = false;
            })
            .catch(function (err) {
              console.log(err);
              console.log("Error loading agency tree nodes");
              me.loading = false;
              throw err;
            });
        }
      }
    },
    selectedAgencyId: function (newVal, oldVal) {
      if (newVal) {
        let me = this;
        me.nodes = [];
        me.programOptions.splice(0, me.programOptions.length);
        me.allNodes.forEach(node => {
          if (node.id === newVal) {
            me.nodes.push(node);
            if (node.children && node.children.length > 0) {
              let idx = 0;
              node.children.forEach(kid => {
                Vue.set(me.programOptions, idx++, { value: kid.id, label: kid.name });
              });
              me.programOptions.sort((a, b) => {
                if (!a.label) return -1;
                if (!b.label) return 1;
                return a.label.localeCompare(b.label);
              });
            }
          }
        });
      }
    },
    selectedProgramId: function (newVal, oldVal) {
      if (newVal) {
        let me = this;
        let newNodes = [];
        me.fieldOptions.splice(0, me.fieldOptions.length);
        me.nodes[0].children.forEach(node => {
          if (node.id === newVal) {
            newNodes.push(node);
            if (node.children && node.children.length > 0) {
              let idx = 0;
              node.children.forEach(kid => {
                Vue.set(me.fieldOptions, idx++, { value: kid.id, label: kid.name });
              });

              me.fieldOptions.sort((a, b) => {
                if (!a.label) return -1;
                if (!b.label) return 1;
                return a.label.localeCompare(b.label);
              });
            }

            me.nodes = newNodes;
          }
        });
      }
    },
    selectedFieldId: function (newVal, oldVal) {
      if (newVal) {
        let me = this;
        let newNodes = [];
        me.branchOptions.splice(0, me.branchOptions.length);
        me.nodes[0].children.forEach(node => {
          if (node.id === newVal) {
            newNodes.push(node);
            if (node.children && node.children.length > 0) {
              let idx = 0;
              node.children.forEach(kid => {
                Vue.set(me.branchOptions, idx++, { value: kid.id, label: kid.name });
              });

              me.branchOptions.sort((a, b) => {
                if (!a.label) return -1;
                if (!b.label) return 1;
                return a.label.localeCompare(b.label);
              });
            }

            me.nodes = newNodes;
          }
        });
      }
    }
  }
};
</script>

<style scoped>
.control-panel {
  background-color: #abc0e6;
  padding: 5px 15px;
  margin-left: -12px;
  margin-right: -12px;
  border-radius: 5px;
}

.control-panel h3 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #05385f;
}

.tree-view-container {
  max-height: 600px;
  overflow-y: auto;
  /* margin-right: 10px; */
  padding-right: 10px;
  /* margin: 10px 15px; */
  /* border: 3px solid #0f5182; */
  /* border-radius: 3px; */
}
.filter-container {
  padding: 0 15px;
}
.offices-tree {
  text-align: left;
}
.padded {
  padding: 15px;
}

.v-text-field >>> input {
  text-align: left;
  padding: 3px;
}

.v-text-field {
  padding-top: 0px;
}

.search-input {
  text-align: left !important;
  /* background-color: white; */
}

/* Trying to add padding to the left side of the selects but none of these work. Need to read more about
 * how to use Vue and not try to fight against it. -GF
 */
/*
.control-panel .v-select__slot {
  padding-left: 5px !important;
}

.control-panel .v-input__slot {
  padding-left: 5px;
}

.v-input__slot {
    padding-left: 5px !important;
    background-color: yellow !important;
}

.control-panel select {
  text-align: left;
  background-color: yellowgreen;
  padding-left: 10px !important;
}

label.v-label.theme--light {
    padding-left: 5px;
}

label.v-label.v-label--is-disabled.theme--light {
    margin-left: 5px !important;
}
*/

.name {
  /* color: #041131; */
  font-weight: bold;
}

.abbrev {
  margin-left: 5px;
  font-weight: normal;
}

.code {
  margin-left: 5px;
  color: rgb(63, 63, 63);
  font-size: 0.85em;
  font-family: "Courier New", Courier, monospace;
}

.type-img {
  height: 30px;
  width: 30px;
  flex-grow: 0;
  margin-top: 3px;
}

/* Trying to make the tree node icons darker, but can't find a way to override.  theme--light seems all powerful. -GF
i.v-icon.notranslate.v-treeview-node__toggle.v-icon--link.material-icons.theme--light.v-treeview-node__toggle--open {
    color: purple !important;
}

div.v-treeview.offices-tree .v-icon {
  color: purple !important;
}
*/
.v-treeview-node__label {
  line-height: 27px !important;
}
</style>
